export default __webpack_public_path__ + "static/media/Clearwellnessimage.2da74a56.png";